
import { motion } from 'framer-motion';

// Define category color styles - now using neutral colors
export const tagColors = {
  "🎯 Strategy": {
    text: "text-gray-700",
    bg: "bg-gray-100",
    accent: "bg-gray-200"
  },
  "🎨 Design": {
    text: "text-gray-700",
    bg: "bg-gray-100",
    accent: "bg-gray-200"
  },
  "💻 Development": {
    text: "text-gray-700",
    bg: "bg-gray-100",
    accent: "bg-gray-200"
  },
  "🤖 AI & Automation": {
    text: "text-gray-700",
    bg: "bg-gray-100",
    accent: "bg-gray-200"
  },
  "📈 Growth": {
    text: "text-gray-700",
    bg: "bg-gray-100",
    accent: "bg-gray-200"
  },
  "💪 Support": {
    text: "text-gray-700",
    bg: "bg-gray-100",
    accent: "bg-gray-200"
  }
};

// Phase color mapping - now using neutral colors
export const phaseColors = {
  "Launch": {
    text: "text-gray-700",
    bg: "bg-gray-50",
    accent: "bg-gray-200"
  },
  "Build": {
    text: "text-gray-700",
    bg: "bg-gray-50",
    accent: "bg-gray-200"
  },
  "Grow": {
    text: "text-gray-700",
    bg: "bg-gray-50",
    accent: "bg-gray-200"
  }
};

// Card background colors - using gray-50 for all cards
export const cardBgColors = {
  Launch: "bg-gray-50",
  Build: "bg-gray-50",
  Grow: "bg-gray-50"
};

// Enhanced hover animation - simplified for cleaner look
export const hoverAnimation = {
  rest: { 
    y: 0,
    scale: 1,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)"
  },
  hover: { 
    y: -4, 
    scale: 1.01,
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.08)"
  }
};

// Container animation for staggered appearance
export const containerVariants = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1,
    transition: { 
      staggerChildren: 0.12,
      delayChildren: 0.1
    } 
  }
};

// Item animation for individual cards
export const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: {
      type: "spring",
      stiffness: 260,
      damping: 20
    }
  }
};
